import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./ClientActivities.scss";

const ClientActivities: React.FC = () => {
  return (
    <>
      <div className="activity-wrapper">
        <span className="activity-header">Activities (4)</span>
        <div className="activities">
          <div className="activity-card bg-green white">
            <div className="content-div">
              <h3>Provide Activity</h3>
              <div className="description">
                <span>Required to start scheduling ongoing therapies</span>
              </div>
            </div>

            <div className="action-div">
              <span className="action">
                Get Started
                <FontAwesomeIcon className="icon-back" icon={faArrowRight} />
              </span>
            </div>
          </div>

          <div className="activity-card bg-yellow black">
            <div className="content-div">
              <h3>Upload documents</h3>
              <div className="description">
                <span>Required before upcoming appointment(s)</span>
              </div>
            </div>

            <div className="action-div">
              <span className="action">
                Upload Documents
                <FontAwesomeIcon className="icon-back" icon={faArrowRight} />
              </span>
            </div>
          </div>

          <div className="activity-card bg-light-pink black">
            <div className="content-div">
              <h3>View Recommendation Summary</h3>
              <div className="description">
                {/* <span>
            Required to start scheduling ongoing therapies
            </span> */}
              </div>
            </div>

            <div className="action-div">
              <span className="action">
                View Summary
                <FontAwesomeIcon className="icon-back" icon={faArrowRight} />
              </span>
            </div>
          </div>

          <div className="activity-card bg-blue white">
            <div className="content-div">
              <h3>View new care plan recommendation</h3>
              <div className="description">
                {/* <span>
            Required to start scheduling ongoing therapies
            </span> */}
              </div>
            </div>
            <div className="action-div">
              <span className="action">
                View Care Plan
                <FontAwesomeIcon className="icon-back" icon={faArrowRight} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(ClientActivities);
